import { getRequestTransportErrorMessage } from '#/utils/requestError';
import {
  SUPPLIER_FIELD_LABELS,
  resolveSupplierFieldLabel,
} from '#/modules/srmMgmt/supplier/helper/formValidationLabels';

// 後端 field 為 JSON path（contacts[1].email、chinese_name）→ 表單 path（contacts.1.email、chineseName）
function toSupplierFormPath(field) {
  return String(field)
    .replace(/\[(\d+)\]/g, '.$1')
    .replace(/_([a-z])/g, (_, c) => c.toUpperCase());
}

function getSupplierFieldLabel(field) {
  if (!field) return '';
  const path = toSupplierFormPath(field);
  return resolveSupplierFieldLabel(path) || SUPPLIER_FIELD_LABELS[path] || field;
}

export function getSupplierApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'SUPPLIER_NOT_FOUND') {
    return data?.message || '找不到供應商資料';
  }

  if (code === 'SUPPLIER_FIELD_TOO_LONG') {
    const label = getSupplierFieldLabel(data?.field);
    return label ? `${label}超過長度上限` : (data?.message || '文字欄位超過長度上限');
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  return data?.message || fallback;
}

export function isSupplierVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
